module.exports = __webpack_public_path__ + "img/passionfruit-grapefruit-xxl.a481c5d8.png";